import StorageHelper from "@/helpers/storage";

const routes = [
  { path: "/", name: "home", component: () => import("@/views/HomeView.vue") },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginView.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    beforeEnter(to, from, next) {
      StorageHelper.removeState("tokens");
      StorageHelper.removeState("recommendations");
      StorageHelper.removeState("exam-answers");
      return next((window.location.href = "/login"));
    },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutView.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/RegisterView.vue"),
  },
  {
    path: "/verify-email",
    name: "verify-email",
    component: () => import("@/views/VerifyEmailView.vue"),
  },
  {
    path: "/resend-verification",
    name: "resend-verification",
    component: () => import("@/views/ResendVerificationView.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("@/views/ForgotPasswordView.vue"),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("@/views/ResetPasswordView.vue"),
  },
  {
    path: "/update",
    name: "update",
    component: () => import("@/views/UpdateView.vue"),
  },
  {
    path: "/parceria",
    name: "parceria",
    component: () => import("@/views/ParceriaView.vue"),
  },
  {
    path: "/aila",
    name: "aila",
    component: () => import("@/views/HomeAilaView.vue"),
  },
  {
    path: "/manage-forms/:formId",
    name: "manage-forms",
    component: () => import("@/views/ManageFormsView.vue"),
  },
];

export default routes;
